// src/constant/introduceData.js

export const JoongguIntro = {
  title: `중구행복돌봄센터 홈페이지를
    방문해 주셔서 감사합니다!`,
  text: `중구행복돌봄센터는 서울중구지역자활센터에서 2005년 가사간병사업을 시작으로 사회서비스사업을 개시하여 노인돌봄종합서비스,장애인활동지원, 재가장기요양(방문요양) 등의 서비스를 제공해 왔습니다.

    운영법인 사회적기업 에스이임파워는 사회적경제 (Social Economy)에 속한 모든 조직의 역량강화 (Empower)에 기여하기 위한 사명을 갖고 설립된 사회적협동조합입니다. '사회적기업가 육성사업', '디지털사회혁신', '사회주택', '지역자활센터 운영' 등의 다양한 사회혁신 사업을 하고있으며, 돌봄사회서비스를 통한 사회적 책임을 강화하기 위하여 2022년 1월 서울중구지역자활센터에서 중구행복돌봄센터를 법인의 지점으로 분리하였습니다.`,
  highlight: `중구행복돌봄센터는 장애인활동지원사업, 가사간병방문지원사업, 재가장기요양(방문요양), 돌봄SOS 등
돌봄이 필요한 이웃을 지원하는 돌봄사회서비스를 제공하고 있습니다.
돌봄 노동자들과 돌봄의 손길이 필요한 이웃들과 함께하며 삶의 질을 높이고,
행복한 삶을 영위하는 작은 희망이 되겠습니다.`,
};

export const SeemPowerIntro = {
  title: `에스이임파워 사회적협동조합 
  이사장 인사말`,
  text: `에스이임파워 사회적협동조합(이하 우리 법인)은 사회적 복지·돌봄 사업을 하는 공익법인이자 사회적기업입니다. 지역사회 아동, 장애인, 노인 등 사회적 약자에게 행복한 복지·돌봄 서비스를 제공하면서 취업 취약계층을 위한 일자리도 창출하는 복합적이고 통합적인 사회적 가치를 창출하고 있습니다.

우리 법인은 유아·아동기를 거쳐 이제 청년기로 향하고 있습니다. 우리 법인의 비전은 지역사회의 복합적 문제를 해결하는 복지·돌봄 사업 그룹사로 성장하는 것입니다. 청년기를 맞이하는 우리 법인은 기존의 사회연대경제, 자활복지, 돌봄 지역사회 등 다양한 사회적 의제 해결에 충실하면서도 「더 채움 돌봄」으로 우리의 사회적 가치를 배가할 것입니다. 「더 채움 돌봄」은 국가의 공적서비스가 못 채우는 영역을 시민과 지역공동체의 힘을 모아 채우자는 발상입니다.

불과 10년 전까지만 해도 "요람에서 무덤까지"라는 복지국가의 기치는 우리 사회의 지향으로 수용되었습니다. 국가를 통해서 복지를 실현하는 꿈이었습니다. 그러나 현실에서 우리가 목도하는 사회와 산업, 경제의 변화는 놀랍도록 빠르고 변화무쌍합니다. "자신이 살던 집과 마을에서 모든가 행복한 생활과 노후를 보장받는 돌봄 사회"는 정부의 힘만으로 가능하지 않습니다. 기존의 사회복지 문법에서 탈피가 필요합니다. 우리 법인이 시민의 힘으로 「더 채움 돌봄」의 기치를 주창하는 이유입니다.`,
  highlight: `고(故) 신영복 선생님은 '우공이산(愚公移山)'의 교훈을 설명하면서, "세상에는 지혜로운 사람과 어리석은 사람 두 종류밖에 없고, 결국 어리석은 자들이 세상을 바꾼다"라고 일갈하였습니다. 여기서 우리는'우(愚)'의 의미를 '우직(愚直)'함으로 이해할 필요가 있습니다. 우리 법인은 「더 채움 돌봄」의 비전을 향하여 누군가 어리석게 보더라도 복지 시민과 더불어 함께 우리의 길을 묵묵히 걷고자 합니다.`,
  auth: `에스이임파워 사회적협동조합 이사장 김성기`,
};

// 법인(SE임파워) 연혁
export const seemPowerHistory = [
  {
    year: '2025',
    events: [
      { date: '8월', title: '사회적기업 취약계층 다수 고용기업 지정' },
      { date: '4월', title: '노원행복돌봄센터 지점 등록' },
      { date: '4월', title: '노원남부지역자활센터 수탁' },
    ],
  },
  {
    year: '2024',
    events: [{ date: '5월', title: '사회적기업 창업 후속지원 사업 선정' }],
  },
  {
    year: '2023',
    events: [{ date: '1월', title: '충남형 다회용기 선순환 모델 구축 사업' }],
  },
  {
    year: '2022',
    events: [
      { date: '12월', title: '주택임대관리업 등록' },
      { date: '1월', title: '중구행복돌봄센터 지점 사업자등록' },
    ],
  },
  {
    year: '2021',
    events: [{ date: '4월', title: '산자부 R&D 바이오헬스케어 선정' }],
  },
  {
    year: '2020',
    events: [
      { date: '12월', title: '자율주택정비사업 공존하우스 1호 준공' },
      { date: '12월', title: '사회적주택 운영기관 선정' },
      { date: '3월', title: '서울중구지역자활센터 수탁' },
    ],
  },
  {
    year: '2019',
    events: [{ date: '7월', title: '키르키즈스탄 KF 실크로드 문화관광 사업' }],
  },
  {
    year: '2018',
    events: [
      { date: '12월', title: '서울 사회적경제 우수기업 인증' },
      { date: '10월', title: '공감e구로 舊도심 스마트시민복지도시 구축' },
    ],
  },
  {
    year: '2017',
    events: [{ date: '10월', title: '창3동 도시재생 공동체 활성화 용역' }],
  },
  {
    year: '2016',
    events: [
      { date: '9월', title: '구로구사회적경제창업지원센터' },
      { date: '5월', title: '기업부설연구소 개설' },
    ],
  },
  {
    year: '2015',
    events: [
      { date: '', title: '사회적기업가 육성사업 창업지원기관(IT특화) 선정' },
    ],
  },
  {
    year: '2014',
    events: [{ date: '11월', title: '고용노동부 사회적기업 인증' }],
  },
  {
    year: '2013',
    events: [
      { date: '7월 12일', title: '고용노동부 사회적협동조합 설립인가' },
      { date: '4월 29일', title: '창립총회' },
    ],
  },
];
// 중구행복돌봄센터 연혁
export const joongguHistory = [
  {
    year: '2022',
    events: [
      {
        date: '1월 12일',
        title: 'SE임파워사회적협동조합 법인지점 중구행복돌봄센터 사업자등록',
        description: '(소재지 : 서울시 중구 다산로 44길 11, 3층)',
      },
    ],
  },
  {
    year: '2021',
    events: [
      {
        date: '12월',
        title: '돌봄SOS 우수기관 평가 선정',
      },
    ],
  },
  {
    year: '2020',
    events: [
      {
        date: '8월',
        title: '돌봄SOS 사업개시',
      },
      {
        date: '3월',
        title: 'SE임파워사회적협동조합으로 법인변경',
      },
    ],
  },
  {
    year: '2013',
    events: [
      {
        date: '6월',
        title: '재가장기요양기관 우수기관 선정',
      },
    ],
  },
  {
    year: '2009',
    events: [
      {
        date: '3월',
        title: '장애인활동보조지원 사업 지정',
      },
    ],
  },
  {
    year: '2008',
    events: [
      {
        date: '9월',
        title: '재가장기요양기관(방문요양) 설치 신고',
      },
    ],
  },
  {
    year: '2007',
    events: [
      {
        date: '5월',
        title: '노인돌보미 바우처사업 지정',
      },
    ],
  },
  {
    year: '2005',
    events: [
      {
        date: '1월',
        title: '복권기금 가사간병사업 개시',
      },
    ],
  },
  {
    year: '2004',
    events: [
      {
        date: '4월',
        title: '중구자활후견기관 보건복지부 지정',
      },
    ],
  },
];
